module.exports = __webpack_public_path__ + "static/media/benito-santos-mexico.6f1c7e89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/benito-santos-mexico.svg
// module id = 274
// module chunks = 0